export default "__VITE_ASSET__XfUXbYUF__"